import React from 'react';

import { Button, Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/next';

import type { LegislativeBody } from '../../../shared/types';
import { BodyContent } from '../BodyContent';

import { useViewMore } from './hooks/useViewMore';

export const ViewMore: React.FC<{ legislativeBody: LegislativeBody }> = ({ legislativeBody }) => {
	const { title: bodyTitle, viewMoreText, allDMs } = legislativeBody;

	const {
		data: { title, petitionAsk },
		actions: { trackViewAllDMsWithinLegislativeBodyClick },
	} = useViewMore(legislativeBody);

	return (
		<Modal
			size="large"
			onClose={() => {}}
			trigger={
				<Button
					data-qa="legislative-bodies-view-more"
					variant="tertiary"
					onClick={() => trackViewAllDMsWithinLegislativeBodyClick(bodyTitle)}
				>
					{viewMoreText}
				</Button>
			}
			className="z-[5000] lg:[&_*]:!col-span-full"
		>
			<ModalHeader title={title} subtitle={petitionAsk} />
			<ModalBody className="!max-h-none p-6">
				<BodyContent legislativeBody={{ ...legislativeBody, viewMoreText: undefined, displayedDMs: allDMs }} />
			</ModalBody>
		</Modal>
	);
};
